<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑发票信息"
      @ok="handleSubmit"
    >
      <a-form
        class="iotplt-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >

        <a-form-item label="户名">
          <a-input
            v-decorator="['account_name', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入户名' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="税号">
          <a-input
            v-decorator="['invoice_no', {
              normalize: this.$lodash.trim,
              rules: [
                { required: true, message: '请输入税号' },
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="地址">
          <a-input
            v-decorator="['address', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="电话">
          <a-input
            v-decorator="['phone_number', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="开户行">
          <a-input
            v-decorator="['bank', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="银行账号">
          <a-input
            v-decorator="['card_no', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>

        <a-form-item label="银行行号">
          <a-input
            v-decorator="['bank_no', {
              normalize: this.$lodash.trim,
              rules: [
                { max: 50, message: '最多50个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findInvoiceInfoForm, updateInvoiceInfo } from '@/api/invoice_info'

export default {
  name: 'EditInvoiceInfo',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'invoice_info' }),
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findInvoiceInfoForm(this.id).then((res) => {
        this.form.setFieldsValue(res.data)
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateInvoiceInfo(this.id, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
